// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"188":"955a2abd3a0ab5a6","190":"955a2abd3a0ab5a6","367":"955a2abd3a0ab5a6","405":"955a2abd3a0ab5a6","521":"955a2abd3a0ab5a6","888":"5e438d6e74af66a9","890":"955a2abd3a0ab5a6","915":"955a2abd3a0ab5a6","932":"955a2abd3a0ab5a6"}[chunkId] + ".css";
};